import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import esMx from '../assets/imgs/mx.png';
import enUs from '../assets/imgs/us.png';
import "./languageSwitcher.scss";

function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const [isChecked,setIsChecked] = useState("");

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleLang(lng);
  };

  const handleLang = (lang) => {
    if(i18n.language === lang) {
      setIsChecked(lang)
    }
    if(i18n.language === lang) {
      setIsChecked(lang)
    }
  }
    
  useEffect(() => {
    handleLang(i18n.language);
  }, [i18n])

  return (
    <div className={"switch-lang"}>
      <label forHtml="radioSp" className={`${(isChecked === "es") ? "checked" : ""}`}>
        <img src={esMx} className='switch-lang__img' />
        <input 
          id="radioSp"
          onChange={() => changeLanguage('es')} 
          type="radio" 
          className='switch-lang__input' 
          name="lang" 
          value="es" 
        />
      </label>
      <label forHtml="radioEn" className={`${(isChecked === "en") ? "checked" : ""}`}>
      <img src={enUs} className='switch-lang__img' />
        <input 
          id="radioEn"
          onChange={() => changeLanguage('en')} 
          type="radio" 
          className='switch-lang__input' 
          name="lang" 
          value="en" 
        />
      </label>
    </div>
  );
}

export default LanguageSwitcher;